import axios from './httpConfig.js'
export * from "./searchOrigin";   // 基本设置

// 获取用户信息
export function GetLoginInfo(param) {
	return axios.post('/getuserinfo', param)
}